import { useCallback, useState } from "react";

import { useRouter } from "next/router";

import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { setPinDetails } from "@/redux/features/place/slice";
import { setView } from "@/redux/features/place-right-panel/slice";
import { setAnswers, setImageDetails } from "@/redux/features/place-form/slice";
import transformAnswers from "@/components/places/utils/transform-answers";
import { useMediaQuery } from "@/storybook-components";
import { getMarkerDetails } from "@/redux/features/place-marker/thunk";

const usePinView = ({
  viewPinModalProps,
  setIsPinclicked
}: {
  viewPinModalProps?: any;
  setIsPinclicked?: any;
}) => {
  const [viewCardLoader, setViewCardLoader] = useState(false);
  const projectId = useAppSelector((state) => state.project.project.id);
  const placesId = useAppSelector((state) => state.place.place.id);
  const questions = useAppSelector((state) => state.placesForm.questions);

  const router = useRouter();
  const [isDesktop] = useMediaQuery("(min-width: 768px)");
  const dispatch = useAppDispatch();
  const viewPinDetails = useAppSelector((state) => state.place.pinDetails);

  const updateImageAnswer = (answers) => {
    const fileQuestion = questions.find((q) => q.type === "FileQuestion");
    const fileUrl = answers?.[fileQuestion?.id]?.answer?.fileUrl;

    dispatch(setImageDetails({ fileUrl }));
  };

  const viewMarkerDetailsScreen = useCallback(
    async (data, cardDetails) => {
      const { asPath } = router;
      const updatedPath = asPath.split("?")?.[0];
      const path = `${updatedPath}?marker=${data.id}`;

      router.replace(path, "", { shallow: true });
      const { ...rest } = viewPinDetails;
      setViewCardLoader(true);
      if (JSON.stringify(rest) !== JSON.stringify(data)) {
        dispatch(setPinDetails({}));
      }

      if (!isDesktop && cardDetails === "custom-marker") {
        setIsPinclicked?.(true);
        viewPinModalProps?.onOpen();
        dispatch(setView("custom-marker"));
      } else {
        dispatch(setView("view-pin-details"));
      }

      if (cardDetails !== "view-marker-data") {
        const res: any = await dispatch(
          getMarkerDetails({ projectId, placesId, markerId: data.id })
        );

        dispatch(
          setPinDetails({
            ...data,
            ...(res?.payload?.answers && { ["answers"]: res?.payload?.answers })
          })
        );
        const markerAnswers = transformAnswers(
          res?.payload?.answers,
          questions
        );
        dispatch(setAnswers(markerAnswers));
        updateImageAnswer(res?.payload?.answers);
      }

      setViewCardLoader(false);
    },
    [isDesktop]
  );
  return { viewMarkerDetailsScreen, viewCardLoader };
};

export default usePinView;
